export interface AuditChangeDiff {
  field: string;
  from: unknown;
  to: unknown;
}

export const isChangesDiff = (value: unknown): value is Record<string, { from: unknown; to: unknown }> => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const entries = Object.entries(value);
  if (!entries.length) return false;
  return entries.every(([, item]) => {
    if (!item || typeof item !== 'object' || Array.isArray(item)) return false;
    return 'from' in item && 'to' in item;
  });
};

export const toChangeRows = (value: unknown): AuditChangeDiff[] | null => {
  if (!isChangesDiff(value)) return null;
  return Object.entries(value).map(([field, item]) => ({
    field,
    from: item.from,
    to: item.to,
  }));
};

export const formatChangeValue = (value: unknown): string => {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return JSON.stringify(value);
};

export const prettyJson = (value: unknown): string => {
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
};
